export default (...classnames) => classnames.join(' ') 